import {css, FlattenSimpleInterpolation} from 'styled-components';

export const mediaMaxXSBreakpoint = 767;
export const mediaMaxMSBreakpoint = 1023;
export const mediaMaxSBreakpoint = 1279;
export const mediaMaxMBreakpoint = 1439;
export const mediaMaxLBreakpoint = 1919;
export const mediaMaxXLBreakpoint = 2559;

export const mediaMobileOnly = `only screen and (max-width: ${mediaMaxXSBreakpoint}px)`;
export const mediaTabletAndDown = `only screen and (max-width: ${mediaMaxMSBreakpoint}px)`;
export const mediaMaxS = `only screen and (max-width: ${mediaMaxSBreakpoint}px)`;
export const mediaMaxM = `only screen and (max-width: ${mediaMaxMBreakpoint}px)`;
export const mediaMaxL = `only screen and (max-width: ${mediaMaxLBreakpoint}px)`;
export const mediaMaxXL = `only screen and (max-width: ${mediaMaxXLBreakpoint}px)`;

export const mediaMinXXXSBreakpoint = 384;
export const mediaMinXXSBreakpoint = 768;
export const mediaMinXSBreakpoint = 1024;
export const mediaHigherDesktopBreakpoint = 1150;
export const mediaMinSBreakpoint = 1280;
export const mediaMinMBreakpoint = 1440;
export const mediaMinLBreakpoint = 1920;
export const mediaMinXLBreakpoint = 2560;

export const mediaMinXXXS = `only screen and (min-width: ${mediaMinXXXSBreakpoint}px)`;
export const mediaTabletAndUp = `only screen and (min-width: ${mediaMinXXSBreakpoint}px)`;
export const mediaDesktopAndUp = `only screen and (min-width: ${mediaMinXSBreakpoint}px)`;
export const mediaHigherDesktop = `only screen and (min-width: ${mediaHigherDesktopBreakpoint}px)`;
export const mediaLargeScreens = `only screen and (min-width: ${mediaMinSBreakpoint}px)`;
export const mediaExtraLargeScreens = `only screen and (min-width: ${mediaMinMBreakpoint}px)`;
export const mediaMinL = `only screen and (min-width: ${mediaMinLBreakpoint}px)`;
export const mediaMinXL = `only screen and (min-width: ${mediaMinXLBreakpoint}px)`;

export const mediaPortrait = `only screen and (orientation: portrait)`;

export const mobileOnly = (styles: FlattenSimpleInterpolation) => css`
  @media ${mediaMobileOnly} {
    ${styles}
  }
`;

export const tabletAndDown = (styles: FlattenSimpleInterpolation) => css`
  @media ${mediaTabletAndDown} {
    ${styles}
  }
`;

export const tabletAndUp = (styles: FlattenSimpleInterpolation) => css`
  @media ${mediaTabletAndUp} {
    ${styles}
  }
`;

export const desktopAndUp = (styles: FlattenSimpleInterpolation) => css`
  @media ${mediaDesktopAndUp} {
    ${styles}
  }
`;

export const higherDesktopAndUp = (styles: FlattenSimpleInterpolation) => css`
  @media ${mediaHigherDesktop} {
    ${styles}
  }
`;

export const largeScreens = (styles: FlattenSimpleInterpolation) => css`
  @media ${mediaLargeScreens} {
    ${styles}
  }
`;

export const extraLargeScreens = (styles: FlattenSimpleInterpolation) => css`
  @media ${mediaExtraLargeScreens} {
    ${styles}
  }
`;

export const extraLargeScreenL = (styles: FlattenSimpleInterpolation) => css`
  @media ${mediaMinL} {
    ${styles}
  }
`;

export const mobileLandscape = (styles: FlattenSimpleInterpolation) => css`
  @media (orientation: landscape) {
    ${styles}
  }
`;

export const supportsHover = (styles: FlattenSimpleInterpolation) => css`
  @media (hover: hover) {
    ${styles}
  }
`;
